import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (_theme, _ref) {
  var transitionDuration = _ref.transitionDuration;
  return {
    control: {},
    root: {
      position: "relative"
    },
    content: {
      overflow: "hidden",
      transitionProperty: "max-height",
      transitionTimingFunction: "ease",
      transitionDuration: "".concat(transitionDuration, "ms"),
      "@media (prefers-reduced-motion)": {
        transitionDuration: "0ms"
      }
    }
  };
});
export default useStyles;